import { render, staticRenderFns } from "./ConsultationDetail.vue?vue&type=template&id=5907cd0c&scoped=true&"
import script from "./ConsultationDetail.vue?vue&type=script&lang=js&"
export * from "./ConsultationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationDetail.vue?vue&type=style&index=0&id=5907cd0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907cd0c",
  null
  
)

export default component.exports